export type GroupSessionType = "academy" | "open_air" | "corporate";

export const GROUP_PRICE_LABEL = "$299";
export const GROUP_SIZE = 4;
export const GROUP_HOURS = 2;

export const GROUP_SESSION_TYPES: Record<GroupSessionType, { name: string; short: string }> = {
  academy: { name: "Let's Fly: Academy (Guided)", short: "Academy" },
  open_air: { name: "Let's Fly: Open Air (Self-Directed)", short: "Open Air" },
  corporate: { name: "Corporate proposal", short: "Corporate" },
};
